function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _assert_this_initialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _class_call_check(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _create_class(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _get_prototype_of(o) {
  _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _possible_constructor_return(self, call) {
  if (call && (_type_of(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
  _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _type_of(obj) {
  "@swc/helpers - typeof";

  return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _create_super(Derived) {
  var hasNativeReflectConstruct = _is_native_reflect_construct();
  return function _createSuperInternal() {
    var Super = _get_prototype_of(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _get_prototype_of(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possible_constructor_return(this, result);
  };
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment EGDSIconFragment on Icon {\n    __typename\n    description\n    id\n    size\n    theme\n    title\n    withBackground\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment EGDSIconTextFragment on EGDSIconText {\n    icon {\n      ...EGDSIconFragment\n    }\n    text\n  }\n\n  ", "\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment EGDSInlineLinkFragment on EGDSInlineLink {\n    uiLinkAction: action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n      }\n      target\n    }\n    disabled\n    size\n    text\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    __typename\n    text\n  }\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    uiLinkAction: action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n      }\n      target\n    }\n    disabled\n    standardLinkIcon: icon {\n      ...EGDSIconFragment\n    }\n    iconPosition\n    size\n    text\n  }\n\n  ", "\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment EGDSTextFragment on EGDSText {\n    __typename\n    text\n    ...EGDSPlainTextFragment\n    ...EGDSInlineLinkFragment\n    ...EGDSStandardLinkFragment\n    ...EGDSIconTextFragment\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    __typename\n    text\n    egdsElementId\n    contents {\n      ...EGDSTextFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment DirectFeedbackTextListFragment on DirectFeedbackTextList {\n    __typename\n    bullet\n    listItems {\n      egdsElementId\n      icon {\n        ...EGDSIconFragment\n      }\n      text {\n        ...EGDSSpannableTextFragment\n      }\n      style\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  fragment EGDSErrorSummaryFragment on EGDSErrorSummary {\n    __typename\n    heading\n    body {\n      text\n    }\n  }\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment EGDSHeadingFragment on EGDSHeading {\n    __typename\n    text\n    headingType\n  }\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  fragment DirectFeedbackDisplayElementFragment on DirectFeedbackFormDisplayElement {\n    __typename\n    ...EGDSErrorSummaryFragment\n    ...EGDSPlainTextFragment\n    ...EGDSHeadingFragment\n    ...EGDSSpannableTextFragment\n    ...DirectFeedbackTextListFragment\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(["\n  fragment EGDSMaxLengthInputValidationFragment on EGDSMaxLengthInputValidation {\n    errorMessage\n    maxLength\n  }\n"]);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject12() {
  var data = _tagged_template_literal(["\n  fragment EGDSMinLengthInputValidationFragment on EGDSMinLengthInputValidation {\n    errorMessage\n    minLength\n  }\n"]);
  _templateObject12 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject13() {
  var data = _tagged_template_literal(["\n  fragment EGDSRegexInputValidationFragment on EGDSRegexInputValidation {\n    errorMessage\n    pattern\n  }\n"]);
  _templateObject13 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject14() {
  var data = _tagged_template_literal(["\n  fragment EGDSRequiredInputValidationFragment on EGDSRequiredInputValidation {\n    errorMessage\n  }\n"]);
  _templateObject14 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject15() {
  var data = _tagged_template_literal(["\n  fragment EGDSInputValidationFragment on EGDSInputValidation {\n    ...EGDSRegexInputValidationFragment\n    ...EGDSMaxLengthInputValidationFragment\n    ...EGDSMinLengthInputValidationFragment\n    ...EGDSRequiredInputValidationFragment\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject15 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject16() {
  var data = _tagged_template_literal(["\n  fragment DirectFeedbackInputFieldFragment on DirectFeedbackInputField {\n    __typename\n    label\n    value\n    name\n    placeholder\n    validations {\n      ...EGDSInputValidationFragment\n    }\n    instructions\n    leftIcon {\n      ...EGDSIconFragment\n    }\n    rightIcon {\n      ...EGDSIconFragment\n    }\n    required\n  }\n  ", "\n  ", "\n"]);
  _templateObject16 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject17() {
  var data = _tagged_template_literal(["\n  fragment EGDSCheckBoxFragment on EGDSCheckBox {\n    __typename\n    description\n    enabled\n    errorMessage\n    label {\n      text\n    }\n    name\n    required\n    state\n  }\n"]);
  _templateObject17 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject18() {
  var data = _tagged_template_literal(["\n  fragment DirectFeedbackMultiSelectGroupFragment on DirectFeedbackMultiSelectGroup {\n    __typename\n    errorMessage\n    groupName\n    multiSelectOptions: options {\n      ...EGDSCheckBoxFragment\n    }\n    selected\n    required\n    legend\n  }\n  ", "\n"]);
  _templateObject18 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject19() {
  var data = _tagged_template_literal(["\n  fragment DirectFeedbackRadioGroupFragment on DirectFeedbackRadioGroup {\n    __typename\n    errorMessage\n    groupName\n    radioGroupOptions: options {\n      description\n      disabled\n      label\n      labelSuffix\n      value\n    }\n    selected\n    required\n    legend\n  }\n"]);
  _templateObject19 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject20() {
  var data = _tagged_template_literal(["\n  fragment DirectFeedbackTextAreaFragment on DirectFeedbackTextArea {\n    __typename\n    label\n    value\n    name\n    placeholder\n    required\n    isEditable\n    minRows\n    maxRows\n    validations {\n      ...EGDSInputValidationFragment\n    }\n    instructions\n    leftIcon {\n      ...EGDSIconFragment\n    }\n    rightIcon {\n      ...EGDSIconFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject20 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject21() {
  var data = _tagged_template_literal(["\n  fragment DirectFeedbackElementFragment on DirectFeedbackFormPageElement {\n    __typename\n    ...EGDSErrorSummaryFragment\n    ...EGDSPlainTextFragment\n    ...EGDSHeadingFragment\n    ...DirectFeedbackMultiSelectGroupFragment\n    ...EGDSSpannableTextFragment\n    ...DirectFeedbackRadioGroupFragment\n    ...DirectFeedbackInputFieldFragment\n    ...DirectFeedbackTextAreaFragment\n    ...DirectFeedbackTextListFragment\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject21 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject22() {
  var data = _tagged_template_literal(["\n  fragment EGDSButtonFragment on EGDSButton {\n    __typename\n    accessibility\n    analytics {\n      __typename\n      referrerId\n      linkName\n    }\n    action {\n      ...UIActionFragment\n    }\n    disabled\n    icon {\n      ...EGDSIconFragment\n    }\n    primary\n  }\n\n  fragment UIActionFragment on UIAction {\n    __typename\n    analytics {\n      __typename\n      referrerId\n      linkName\n    }\n    accessibility\n  }\n"]);
  _templateObject22 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject23() {
  var data = _tagged_template_literal(["\n  fragment UIPrimaryButtonFragment on UIPrimaryButton {\n    ...EGDSButtonFragment\n  }\n\n  ", "\n"]);
  _templateObject23 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject24() {
  var data = _tagged_template_literal(["\n  fragment UISecondaryButtonFragment on UISecondaryButton {\n    ...EGDSButtonFragment\n  }\n\n  ", "\n"]);
  _templateObject24 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject25() {
  var data = _tagged_template_literal(["\n  fragment DirectFeedbackPageFragment on DirectFeedbackFormPage {\n    title\n    subtitle {\n      ...EGDSTextFragment\n    }\n    id\n    commands {\n      action {\n        ...DirectFeedbackOpenNextPageActionFragment\n\n        ...DirectFeedbackOpenPreviousPageActionFragment\n\n        ...DirectFeedbackSubmitFormActionFragment\n      }\n\n      ...EGDSButtonFragment\n    }\n    displayConditions {\n      fieldId\n      expectedValue\n      conditionType\n    }\n    elements {\n      __typename\n      ...DirectFeedbackElementFragment\n    }\n    footer {\n      __typename\n      ...DirectFeedbackDisplayElementFragment\n    }\n  }\n\n  fragment DirectFeedbackOpenNextPageActionFragment on DirectFeedbackOpenNextPageAction {\n    __typename\n    destinationId\n  }\n\n  fragment DirectFeedbackOpenPreviousPageActionFragment on DirectFeedbackOpenPreviousPageAction {\n    __typename\n    analytics {\n      linkName\n    }\n  }\n\n  fragment DirectFeedbackSubmitFormActionFragment on DirectFeedbackSubmitFormAction {\n    __typename\n    analytics {\n      linkName\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject25 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject26() {
  var data = _tagged_template_literal(["\n  fragment DirectFeedbackPagesFragment on DirectFeedbackPrompt {\n    pages {\n      ...DirectFeedbackPageFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject26 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject27() {
  var data = _tagged_template_literal(["\n  query DirectFeedbackQuery($context: ContextInput!, $promptId: ID!) {\n    directFeedbackPromptById(context: $context, id: $promptId) {\n      ...DirectFeedbackPromptByIdFragment\n    }\n  }\n\n  fragment DirectFeedbackPromptByIdFragment on DirectFeedbackPrompt {\n    title\n    challenges {\n      action {\n        ... on ArkoseChallenge {\n          apiKey\n          src\n        }\n      }\n    }\n    ...DirectFeedbackPagesFragment\n  }\n\n  ", "\n"]);
  _templateObject27 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject28() {
  var data = _tagged_template_literal(["\n  mutation DirectFeedbackSubmit($context: ContextInput!, $id: ID!, $feedback: DirectFeedbackValuesInput!) {\n    directFeedbackSubmit(context: $context, id: $id, feedback: $feedback) {\n      errors {\n        ...DirectFeedbackSubmitErrorFragment\n      }\n    }\n  }\n\n  fragment DirectFeedbackSubmitErrorFragment on DirectFeedbackFieldError {\n    fieldId\n    error\n  }\n"]);
  _templateObject28 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject29() {
  var data = _tagged_template_literal(["\n  fragment EGDSImageLinkFragment on EGDSImageLink {\n    uiLinkAction: action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n      }\n      target\n    }\n    image {\n      altText\n      aspectRatio\n      description\n      thumbnailClickAnalytics {\n        linkName\n        referrerId\n      }\n      url\n    }\n  }\n"]);
  _templateObject29 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject30() {
  var data = _tagged_template_literal(["\n  fragment UITertiaryButtonFragment on UITertiaryButton {\n    ...EGDSButtonFragment\n  }\n\n  ", "\n"]);
  _templateObject30 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject31() {
  var data = _tagged_template_literal(["\n  fragment DirectFeedbackCallToActionFragment on DirectFeedbackCallToAction {\n    promptId\n    eager\n    callToAction {\n      __typename\n      ...UIPrimaryButtonFragment\n      ...UISecondaryButtonFragment\n      ...UITertiaryButtonFragment\n      ...EGDSStandardLinkFragment\n      ...EGDSImageLinkFragment\n      ...EGDSInlineLinkFragment\n    }\n    postSubmitDisplay {\n      __typename\n      ...UIPrimaryButtonFragment\n      ...UISecondaryButtonFragment\n      ...UITertiaryButtonFragment\n      ...EGDSStandardLinkFragment\n      ...EGDSSpannableTextFragment\n      ...EGDSInlineLinkFragment\n      ...EGDSImageLinkFragment\n    }\n    contextValues {\n      ...GraphQLPairFragment\n    }\n  }\n\n  fragment GraphQLPairFragment on GraphQLPair {\n    key\n    value\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject31 = function _templateObject() {
    return data;
  };
  return data;
}
var __defProp = Object.defineProperty;
var __defNormalProp = function (obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __publicField = function (obj, key, value) {
  __defNormalProp(obj, (typeof key === "undefined" ? "undefined" : _type_of(key)) !== "symbol" ? key + "" : key, value);
  return value;
};
// src/components/direct-feedback/direct-feedback-dialog.tsx
import React26, { useCallback as useCallback12, useState as useState7 } from "react";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
import { useLocalization } from "@shared-ui/localization-context";
import { ViewLarge, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkSheet, UitkSheetContent, UitkSheetTransition } from "uitk-react-sheet";
import { UitkToolbar } from "uitk-react-toolbar";
// src/components/direct-feedback/direct-feedback-events.ts
var DirectFeedbackEventType = /* @__PURE__ */function (DirectFeedbackEventType2) {
  DirectFeedbackEventType2[DirectFeedbackEventType2["Submit"] = 0] = "Submit";
  DirectFeedbackEventType2[DirectFeedbackEventType2["Close"] = 1] = "Close";
  DirectFeedbackEventType2[DirectFeedbackEventType2["Error"] = 2] = "Error";
  DirectFeedbackEventType2[DirectFeedbackEventType2["Load"] = 3] = "Load";
  DirectFeedbackEventType2[DirectFeedbackEventType2["SetValue"] = 4] = "SetValue";
  DirectFeedbackEventType2[DirectFeedbackEventType2["Open"] = 5] = "Open";
  return DirectFeedbackEventType2;
}(DirectFeedbackEventType || {});
var DirectFeedbackErrorEvent = function DirectFeedbackErrorEvent(promptId, error) {
  "use strict";

  _class_call_check(this, DirectFeedbackErrorEvent);
  __publicField(this, "type", 2 /* Error */);
  __publicField(this, "promptId");
  __publicField(this, "error");
  this.promptId = promptId;
  this.error = error;
};
var DirectFeedbackCloseEvent = function DirectFeedbackCloseEvent(promptId) {
  "use strict";

  _class_call_check(this, DirectFeedbackCloseEvent);
  __publicField(this, "type", 1 /* Close */);
  __publicField(this, "promptId");
  this.promptId = promptId;
};
var DirectFeedbackSubmitEvent = function DirectFeedbackSubmitEvent(promptId, context, formValues) {
  "use strict";

  _class_call_check(this, DirectFeedbackSubmitEvent);
  __publicField(this, "type", 0 /* Submit */);
  __publicField(this, "promptId");
  __publicField(this, "context");
  __publicField(this, "formValues");
  this.promptId = promptId;
  this.context = context;
  this.formValues = formValues;
};
var DirectFeedbackLoadEvent = function DirectFeedbackLoadEvent(promptId, data) {
  "use strict";

  _class_call_check(this, DirectFeedbackLoadEvent);
  __publicField(this, "type", 3 /* Load */);
  __publicField(this, "promptId");
  __publicField(this, "data");
  this.promptId = promptId;
  this.data = data;
};
var DirectFeedbackFormValueChanged = function DirectFeedbackFormValueChanged(promptId, fieldId, value) {
  "use strict";

  _class_call_check(this, DirectFeedbackFormValueChanged);
  __publicField(this, "type", 4 /* SetValue */);
  __publicField(this, "fieldId");
  __publicField(this, "promptId");
  __publicField(this, "value");
  this.fieldId = fieldId;
  this.promptId = promptId;
  this.value = value;
};
// src/components/direct-feedback/direct-feedback-prompt.tsx
import React25, { useCallback as useCallback11, useEffect as useEffect2, useMemo as useMemo6, useRef, useState as useState6 } from "react";
import { gql as gql28, useMutation, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { UitkErrorSummary as UitkErrorSummary2 } from "uitk-react-error-summary";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
// src/components/direct-feedback/__private/__fragments/direct-feedback-pages.tsx
import React23, { useCallback as useCallback10, useEffect, useReducer, useState as useState5 } from "react";
import { gql as gql27 } from "@apollo/client";
// src/components/direct-feedback/__private/direct-feedback-commands.tsx
var DirectFeedbackSubmitCommand = function DirectFeedbackSubmitCommand(action) {
  "use strict";

  _class_call_check(this, DirectFeedbackSubmitCommand);
  __publicField(this, "type", 0 /* Submit */);
  __publicField(this, "action");
  this.action = action;
};
var DirectFeedbackPreviousCommand = function DirectFeedbackPreviousCommand(action) {
  "use strict";

  _class_call_check(this, DirectFeedbackPreviousCommand);
  __publicField(this, "type", 1 /* Previous */);
  __publicField(this, "action");
  this.action = action;
};
var DirectFeedbackNextCommand = function DirectFeedbackNextCommand(action) {
  "use strict";

  _class_call_check(this, DirectFeedbackNextCommand);
  __publicField(this, "type", 2 /* Next */);
  __publicField(this, "action");
  this.action = action;
};
var DirectFeedbackSetValueCommand = function DirectFeedbackSetValueCommand(fieldId, value, isValid) {
  "use strict";

  _class_call_check(this, DirectFeedbackSetValueCommand);
  __publicField(this, "type", 3 /* SetValue */);
  __publicField(this, "fieldId");
  __publicField(this, "value");
  __publicField(this, "isValid");
  this.fieldId = fieldId;
  this.value = value;
  this.isValid = isValid;
};
// src/components/direct-feedback/__private/direct-feedback-loading-spinner.tsx
import React from "react";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLoader } from "uitk-react-loader";
var LoadingContent = function () {
  return /* @__PURE__ */React.createElement(UitkLayoutFlex, {
    justifyContent: "center"
  }, /* @__PURE__ */React.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React.createElement(UitkLoader, null)));
};
// src/components/direct-feedback/__private/__fragments/direct-feedback-page.tsx
import React22, { useCallback as useCallback9, useMemo as useMemo5 } from "react";
import { gql as gql26 } from "@apollo/client";
import { UitkForm } from "uitk-react-form";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2, UitkSubheading } from "uitk-react-text";
// src/components/direct-feedback/__private/__fragments/direct-feedback-display-element.tsx
import React12 from "react";
import { gql as gql11 } from "@apollo/client";
// src/components/direct-feedback/__private/__fragments/direct-feedback-text-list.tsx
import React9 from "react";
import { gql as gql8 } from "@apollo/client";
import { UitkList, UitkListItem } from "uitk-react-list";
// src/components/direct-feedback/__private/__fragments/egds-icon.tsx
import React2, { useMemo } from "react";
import { gql } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
var fragment = gql(_templateObject());
var idIncrementor = 0;
var EGDSIcon = function (param) {
  var data = param.data;
  var id = useMemo(function () {
    idIncrementor += 1;
    return idIncrementor;
  }, []);
  var _data_title, _data_theme;
  return /* @__PURE__ */React2.createElement(UitkIcon, {
    description: data.description,
    name: data.id,
    id: "uitk-icon-".concat(data.id, "-").concat(id),
    size: data.size ? UitkIconSize[data.size] : void 0,
    title: (_data_title = data.title) !== null && _data_title !== void 0 ? _data_title : void 0,
    theme: (_data_theme = data.theme) !== null && _data_theme !== void 0 ? _data_theme : void 0,
    shadow: Boolean(data.withBackground)
  });
};
EGDSIcon.displayName = "EGDSIcon";
EGDSIcon.fragment = fragment;
// src/components/direct-feedback/__private/__fragments/egds-spannable-text.tsx
import React8 from "react";
import { gql as gql7 } from "@apollo/client";
// src/components/direct-feedback/__private/__fragments/egds-text.tsx
import React7 from "react";
import { gql as gql6 } from "@apollo/client";
// src/components/direct-feedback/__private/__fragments/egds-icon-text.tsx
import React3 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";
var fragment2 = gql2(_templateObject1(), EGDSIcon.fragment);
var EGDSIconText = function (param) {
  var data = param.data;
  var icon = data.icon,
    text = data.text;
  return /* @__PURE__ */React3.createElement(React3.Fragment, null, /* @__PURE__ */React3.createElement(UitkSpacing, {
    margin: {
      inlineend: "one"
    }
  }, /* @__PURE__ */React3.createElement(EGDSIcon, {
    data: icon
  })), /* @__PURE__ */React3.createElement(UitkSpacing, {
    margin: {
      inlineend: "one"
    }
  }, /* @__PURE__ */React3.createElement(UitkText, {
    inline: true
  }, text)));
};
EGDSIconText.fragment = fragment2;
EGDSIconText.displayName = "EGDSIconText";
// src/components/direct-feedback/__private/__fragments/egds-inline-link.tsx
import React4, { useMemo as useMemo2 } from "react";
import { gql as gql3 } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkLink } from "uitk-react-link";
var fragment3 = gql3(_templateObject2());
var _obj;
var linkSizeMapper = (_obj = {}, _define_property(_obj, "SMALL" /* SMALL */, "small"), _define_property(_obj, "MEDIUM" /* MEDIUM */, "medium"), _define_property(_obj, "LARGE" /* LARGE */, "large"), _obj);
var _obj1;
var UILinkTargetMap = (_obj1 = {}, _define_property(_obj1, "EXTERNAL" /* EXTERNAL */, "_blank"), _define_property(_obj1, "INTERNAL" /* INTERNAL */, "_self"), _obj1);
var EGDSInlineLink = function (param) {
  var onClick = param.onClick,
    _param_data = param.data,
    _param_data_uiLinkAction = _param_data.uiLinkAction,
    analytics = _param_data_uiLinkAction.analytics,
    resource = _param_data_uiLinkAction.resource,
    target = _param_data_uiLinkAction.target,
    accessibility = _param_data_uiLinkAction.accessibility,
    disabled = _param_data.disabled,
    size = _param_data.size,
    text = _param_data.text;
  var track = useClickTracker();
  var uitkLinkAnalytics = useMemo2(function () {
    return {
      id: analytics.referrerId,
      description: analytics.linkName,
      callback: function (id, description, event) {
        track(id, description);
      }
    };
  }, [analytics, track]);
  return /* @__PURE__ */React4.createElement(UitkLink, {
    size: "large",
    disabled: disabled,
    analytics: uitkLinkAnalytics,
    onClick: onClick,
    inline: true
  }, /* @__PURE__ */React4.createElement("a", {
    href: resource.value,
    target: UILinkTargetMap[target]
  }, text, accessibility && /* @__PURE__ */React4.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility)));
};
EGDSInlineLink.fragment = fragment3;
EGDSInlineLink.displayName = "EGDSInlineLink";
// src/components/direct-feedback/__private/__fragments/egds-plain-text.tsx
import React5 from "react";
import { gql as gql4 } from "@apollo/client";
import { UitkText as UitkText2 } from "uitk-react-text";
var fragment4 = gql4(_templateObject3());
var EGDSPlainText = function (param) {
  var data = param.data,
    _param_inline = param.inline,
    inline = _param_inline === void 0 ? false : _param_inline;
  return /* @__PURE__ */React5.createElement(UitkText2, {
    size: 400,
    inline: inline
  }, data.text);
};
EGDSPlainText.fragment = fragment4;
EGDSPlainText.displayName = "EGDSPlainText";
// src/components/direct-feedback/__private/__fragments/egds-standard-link.tsx
import React6 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkLink as UitkLink2 } from "uitk-react-link";
import { UitkText as UitkText3 } from "uitk-react-text";
var fragment5 = gql5(_templateObject4(), EGDSIcon.fragment);
var IconPlacement = function (param) {
  var icon = param.icon,
    iconPosition = param.iconPosition,
    iconPositionToMatch = param.iconPositionToMatch;
  if (icon && iconPosition === iconPositionToMatch) {
    return /* @__PURE__ */React6.createElement(EGDSIcon, {
      data: icon
    });
  }
  return null;
};
var EGDSStandardLink = function (param) {
  var className = param.className,
    inline = param.inline,
    onClick = param.onClick,
    _param_data = param.data,
    _param_data_uiLinkAction = _param_data.uiLinkAction,
    resource = _param_data_uiLinkAction.resource,
    target = _param_data_uiLinkAction.target,
    accessibility = _param_data_uiLinkAction.accessibility,
    disabled = _param_data.disabled,
    iconPosition = _param_data.iconPosition,
    standardLinkIcon = _param_data.standardLinkIcon,
    size = _param_data.size,
    text = _param_data.text;
  return /* @__PURE__ */React6.createElement(UitkLink2, {
    className: className,
    size: linkSizeMapper[size],
    inline: inline,
    disabled: disabled,
    onClick: onClick
  }, /* @__PURE__ */React6.createElement("a", {
    target: UILinkTargetMap[target],
    href: resource.value
  }, /* @__PURE__ */React6.createElement(IconPlacement, {
    icon: standardLinkIcon,
    iconPosition: iconPosition,
    iconPositionToMatch: "LEADING" /* LEADING */
  }), text, /* @__PURE__ */React6.createElement(IconPlacement, {
    icon: standardLinkIcon,
    iconPosition: iconPosition,
    iconPositionToMatch: "TRAILING" /* TRAILING */
  }), accessibility && /* @__PURE__ */React6.createElement(UitkText3, {
    className: "is-visually-hidden"
  }, accessibility)));
};
EGDSStandardLink.fragment = fragment5;
EGDSStandardLink.displayName = "EGDSStandardLink";
// src/components/direct-feedback/__private/__fragments/egds-text.tsx
var fragment6 = gql6(_templateObject5(), EGDSIconText.fragment, EGDSPlainText.fragment, EGDSInlineLink.fragment, EGDSStandardLink.fragment);
var EGDSTextConcreteTypeLookup = {
  EGDSPlainText: EGDSPlainText,
  EGDSInlineLink: EGDSInlineLink,
  EGDSStandardLink: EGDSStandardLink,
  EGDSIconText: EGDSIconText
};
var EGDSText = function (param) {
  var data = param.data,
    _param_inline = param.inline,
    inline = _param_inline === void 0 ? false : _param_inline;
  var Component = EGDSTextConcreteTypeLookup[data.__typename] || EGDSPlainText;
  return /* @__PURE__ */React7.createElement(Component, {
    inline: inline,
    data: data
  });
};
EGDSText.fragment = fragment6;
EGDSText.displayName = "EGDSText";
// src/components/direct-feedback/__private/__fragments/egds-spannable-text.tsx
var fragment7 = gql7(_templateObject6(), EGDSText.fragment);
var EGDSSpannableText = function (param) {
  var data = param.data;
  return /* @__PURE__ */React8.createElement(React8.Fragment, null, data.contents ? data.contents.map(function (element, index) {
    return /* @__PURE__ */React8.createElement(EGDSText, {
      inline: true,
      data: element,
      key: "EGDSSpannableTextContents_".concat(index)
    });
  }) : /* @__PURE__ */React8.createElement(EGDSText, {
    data: data
  }));
};
EGDSSpannableText.fragment = fragment7;
EGDSSpannableText.displayName = "EGDSSpannableText";
// src/components/direct-feedback/__private/__fragments/direct-feedback-text-list.tsx
var fragment8 = gql8(_templateObject7(), EGDSIcon.fragment, EGDSSpannableText.fragment);
var _obj2;
var bulletStyle = (_obj2 = {}, _define_property(_obj2, "DEFAULT" /* DEFAULT */, "default"), _define_property(_obj2, "ICON_ALTERNATE" /* ICON_ALTERNATE */, "icon-alternate"), _define_property(_obj2, "ICON_STANDARD" /* ICON_STANDARD */, "icon-standard"), _define_property(_obj2, "NO_BULLET" /* NO_BULLET */, "no-bullet"), _define_property(_obj2, "UNRECOGNIZED" /* UNRECOGNIZED */, void 0), _obj2);
var DirectFeedbackTextList = function (param) {
  var data = param.data;
  return data.listItems.length ? /* @__PURE__ */React9.createElement(UitkList, {
    bullet: bulletStyle[data.bullet]
  }, data.listItems.map(function (param) {
    var icon = param.icon,
      egdsElementId = param.egdsElementId,
      text = param.text;
    return /* @__PURE__ */React9.createElement(UitkListItem, {
      key: egdsElementId
    }, icon ? /* @__PURE__ */React9.createElement(EGDSIcon, {
      data: icon
    }) : null, text.__typename === "EGDSSpannableText" && /* @__PURE__ */React9.createElement(EGDSSpannableText, {
      data: text
    }));
  })) : null;
};
DirectFeedbackTextList.fragment = fragment8;
DirectFeedbackTextList.displayName = "DirectFeedbackTextList";
// src/components/direct-feedback/__private/__fragments/egds-error-summary.tsx
import React10 from "react";
import { gql as gql9 } from "@apollo/client";
import { UitkErrorSummary } from "uitk-react-error-summary";
var fragment9 = gql9(_templateObject8());
var EGDSErrorSummary = function (param) {
  var _param_data = param.data,
    heading = _param_data.heading,
    body = _param_data.body;
  var _body;
  var description = (_body = body) === null || _body === void 0 ? void 0 : _body.text;
  return /* @__PURE__ */React10.createElement(UitkErrorSummary, {
    heading: heading,
    description: description
  });
};
EGDSErrorSummary.displayName = "ErrorSummary";
EGDSErrorSummary.fragment = fragment9;
EGDSErrorSummary.fragment.__typename = "EGDSErrorSummary";
// src/components/direct-feedback/__private/__fragments/egds-heading.tsx
import React11 from "react";
import { gql as gql10 } from "@apollo/client";
import { UitkHeading } from "uitk-react-text";
var fragment10 = gql10(_templateObject9());
var _obj3;
var headingTagMapper = (_obj3 = {}, _define_property(_obj3, "H1" /* H1 */, "h1"), _define_property(_obj3, "H2" /* H2 */, "h2"), _define_property(_obj3, "H3" /* H3 */, "h3"), _define_property(_obj3, "H4" /* H4 */, "h4"), _define_property(_obj3, "H5" /* H5 */, "h5"), _define_property(_obj3, "H6" /* H6 */, "h6"), _define_property(_obj3, "H7" /* H7 */, "h6"), _define_property(_obj3, "H8" /* H8 */, "h6"), _obj3);
var EGDSHeading = function (param) {
  var data = param.data;
  return /* @__PURE__ */React11.createElement(UitkHeading, {
    tag: data.headingType ? headingTagMapper[data.headingType] : void 0
  }, data.text);
};
EGDSHeading.fragment = fragment10;
EGDSHeading.displayName = "EGDSHeading";
// src/components/direct-feedback/__private/__fragments/direct-feedback-display-element.tsx
var fragment11 = gql11(_templateObject10(), EGDSErrorSummary.fragment, EGDSPlainText.fragment, EGDSHeading.fragment, EGDSSpannableText.fragment, DirectFeedbackTextList.fragment);
var EgdsDisplayFragmentLookup = {
  EGDSPlainText: EGDSPlainText,
  EGDSHeading: EGDSHeading,
  EGDSSpannableText: EGDSSpannableText,
  DirectFeedbackTextList: DirectFeedbackTextList,
  EGDSErrorSummary: EGDSErrorSummary
};
var DirectFeedbackDisplayElement = function (props) {
  var data = props.data;
  var DisplayComponentImplementation = EgdsDisplayFragmentLookup[data.__typename];
  if (DisplayComponentImplementation) {
    return /* @__PURE__ */React12.createElement(DisplayComponentImplementation, {
      data: data
    });
  }
  return /* @__PURE__ */React12.createElement("pre", null, JSON.stringify(data, null, 2));
};
DirectFeedbackDisplayElement.fragment = fragment11;
DirectFeedbackDisplayElement.displayName = "DirectFeedbackDisplayElement";
DirectFeedbackDisplayElement.supportedTypes = Object.keys(EgdsDisplayFragmentLookup);
// src/components/direct-feedback/__private/__fragments/direct-feedback-element.tsx
import React18, { useCallback as useCallback5 } from "react";
import { gql as gql22 } from "@apollo/client";
// src/components/direct-feedback/__private/__fragments/direct-feedback-input-field.tsx
import React13, { useCallback, useMemo as useMemo3, useState } from "react";
import { gql as gql17 } from "@apollo/client";
import { UitkTextInput } from "uitk-react-input";
// src/components/direct-feedback/__private/__fragments/validation/egds-input-validation.ts
import { gql as gql16 } from "@apollo/client";
// src/components/direct-feedback/__private/__fragments/validation/egds-max-length-input-validation.ts
import { gql as gql12 } from "@apollo/client";
var fragment12 = gql12(_templateObject11());
var defaultValidator = function (value, validation) {
  if (value && value.length > validation.maxLength) {
    return {
      invalid: validation.errorMessage
    };
  }
  return {};
};
var EGDSMaxLengthInputValidation = function (validation) {
  return {
    validate: function (value) {
      return defaultValidator(value, validation);
    }
  };
};
EGDSMaxLengthInputValidation.fragment = fragment12;
// src/components/direct-feedback/__private/__fragments/validation/egds-min-length-input-validation.ts
import { gql as gql13 } from "@apollo/client";
var fragment13 = gql13(_templateObject12());
var defaultValidator2 = function (value, validation) {
  if (value && value.length < validation.minLength) {
    return {
      invalid: validation.errorMessage
    };
  }
  return {};
};
var EGDSMinLengthInputValidation = function (validation) {
  return {
    validate: function (value) {
      return defaultValidator2(value, validation);
    }
  };
};
EGDSMinLengthInputValidation.fragment = fragment13;
// src/components/direct-feedback/__private/__fragments/validation/egds-regex-input-validation.ts
import { gql as gql14 } from "@apollo/client";
var fragment14 = gql14(_templateObject13());
var defaultValidator3 = function (value, validation) {
  var _value;
  var re = new RegExp(validation.pattern);
  if (((_value = value) === null || _value === void 0 ? void 0 : _value.trim()) && !value.match(re)) {
    return {
      invalid: validation.errorMessage
    };
  }
  return {};
};
var EGDSRegexInputValidation = function (validation) {
  return {
    validate: function (value) {
      return defaultValidator3(value, validation);
    }
  };
};
EGDSRegexInputValidation.fragment = fragment14;
// src/components/direct-feedback/__private/__fragments/validation/egds-required-input-validation.ts
import { gql as gql15 } from "@apollo/client";
var fragment15 = gql15(_templateObject14());
var defaultValidator4 = function (value, validation) {
  var _value;
  if (!((_value = value) === null || _value === void 0 ? void 0 : _value.trim())) {
    return {
      invalid: validation.errorMessage
    };
  }
  return {};
};
var EGDSRequiredInputValidation = function (validation) {
  return {
    validate: function (value) {
      return defaultValidator4(value, validation);
    }
  };
};
EGDSRequiredInputValidation.fragment = fragment15;
// src/components/direct-feedback/__private/__fragments/validation/egds-input-validation.ts
var fragment16 = gql16(_templateObject15(), EGDSRegexInputValidation.fragment, EGDSRequiredInputValidation.fragment, EGDSMaxLengthInputValidation.fragment, EGDSMinLengthInputValidation.fragment);
var getValidators = function (validations) {
  return validations.map(function (validation) {
    switch (validation.__typename) {
      case "EGDSRegexInputValidation":
        return _object_spread({}, validation, EGDSRegexInputValidation(validation));
      case "EGDSMaxLengthInputValidation":
        return _object_spread({}, validation, EGDSMaxLengthInputValidation(validation));
      case "EGDSMinLengthInputValidation":
        return _object_spread({}, validation, EGDSMinLengthInputValidation(validation));
      case "EGDSRequiredInputValidation":
        return _object_spread({}, validation, EGDSRequiredInputValidation(validation));
      default:
        return {
          validate: function () {
            return {};
          }
        };
    }
  });
};
var getValidator = function (validations) {
  var validators = getValidators(validations || []);
  return {
    validate: function (value) {
      return validators.map(function (validator) {
        return validator.validate(value);
      }).find(function (result) {
        var _result;
        return ((_result = result) === null || _result === void 0 ? void 0 : _result.invalid) !== void 0;
      }) || {};
    }
  };
};
// src/components/direct-feedback/__private/__fragments/direct-feedback-input-field.tsx
var fragment17 = gql17(_templateObject16(), fragment16, EGDSIcon.fragment);
var idIncrementor2 = 0;
var DirectFeedbackInputField = function (props) {
  var _leftIcon;
  var _props_data = props.data,
    label = _props_data.label,
    required = _props_data.required,
    placeholder = _props_data.placeholder,
    dataValue = _props_data.value,
    name = _props_data.name,
    leftIcon = _props_data.leftIcon,
    validations = _props_data.validations,
    onChange = props.onChange,
    value = props.value;
  var id = useMemo3(function () {
    idIncrementor2 += 1;
    return idIncrementor2;
  }, []);
  var validator = useMemo3(function () {
    return getValidator(validations);
  }, [validations]);
  var _useState = _sliced_to_array(useState(void 0), 2),
    errorMessage = _useState[0],
    setErrorMessage = _useState[1];
  var handleChange = useCallback(function (e) {
    if (onChange) {
      var error = validator.validate(e.target.value).invalid;
      setErrorMessage(error);
      onChange(e.target.name, e.target.value, error === void 0 && (!required || !!e.target.value));
    }
  }, [onChange, required, validator]);
  return /* @__PURE__ */React13.createElement(UitkTextInput, {
    id: "uitk-text-input-".concat(name, "-").concat(id),
    label: label || "",
    value: value || dataValue || void 0,
    name: name || void 0,
    hasVisibleLabel: label !== "",
    placeholder: placeholder || void 0,
    required: required || false,
    onChange: handleChange,
    icon: ((_leftIcon = leftIcon) === null || _leftIcon === void 0 ? void 0 : _leftIcon.id) || void 0,
    invalid: errorMessage
  });
};
DirectFeedbackInputField.fragment = fragment17;
DirectFeedbackInputField.displayName = "DirectFeedbackInputField";
// src/components/direct-feedback/__private/__fragments/direct-feedback-multi-select-group.tsx
import React15, { useCallback as useCallback2, useState as useState2 } from "react";
import { gql as gql19 } from "@apollo/client";
import { UitkCheckboxGroup } from "uitk-react-checkbox";
// src/components/direct-feedback/__private/__fragments/egds-check-box.tsx
import React14 from "react";
import { gql as gql18 } from "@apollo/client";
import { UitkCheckbox } from "uitk-react-checkbox";
var fragment18 = gql18(_templateObject17());
var EGDSCheckBox = function (param) {
  var data = param.data,
    onChange = param.onChange,
    checked = param.checked,
    required = param.required;
  var _data_label;
  return /* @__PURE__ */React14.createElement(UitkCheckbox, {
    checked: checked !== null ? checked : data.state === "CHECKED" /* CHECKED */,
    indeterminate: checked !== null && data.state === "INDETERMINATE" /* INDETERMINATE */,
    description: data.description || void 0,
    required: data.required || required,
    label: (_data_label = data.label) === null || _data_label === void 0 ? void 0 : _data_label.text,
    disabled: !data.enabled,
    name: data.name || void 0,
    id: data.name || void 0,
    errorMessage: data.errorMessage || void 0,
    onChange: function (e) {
      if (onChange) {
        onChange(data.name, e.currentTarget.checked);
      }
    }
  }, data.label.text);
};
EGDSCheckBox.fragment = fragment18;
EGDSCheckBox.displayName = "EGDSCheckBox";
// src/components/direct-feedback/__private/__fragments/direct-feedback-multi-select-group.tsx
var fragment19 = gql19(_templateObject18(), EGDSCheckBox.fragment);
var reducer = function (state, event) {
  var values = state.values;
  if (!event.value) {
    values = values.filter(function (name) {
      return name !== event.name;
    });
  } else if (!state.values.includes(event.name)) {
    values = values.concat([event.name]);
  }
  return {
    values: values
  };
};
var DirectFeedbackMultiSelectGroup = function (param) {
  var data = param.data,
    onChange = param.onChange,
    value = param.value;
  var _data_selected;
  var groupName = data.groupName,
    errorMessage = data.errorMessage,
    options = data.multiSelectOptions,
    required = data.required,
    legend = data.legend;
  var _useState2 = _sliced_to_array(useState2({
      values: value || ((_data_selected = data.selected) === null || _data_selected === void 0 ? void 0 : _data_selected.split(",")) || []
    }), 2),
    state = _useState2[0],
    setState = _useState2[1];
  var handleCheckChange = useCallback2(function (name, newValue) {
    var newState = reducer(state, {
      name: name,
      value: newValue
    });
    setState(newState);
    if (onChange) {
      var _newState_values;
      onChange(groupName, newState.values, !required || !!((_newState_values = newState.values) === null || _newState_values === void 0 ? void 0 : _newState_values.length));
    }
  }, [onChange, groupName, required, state]);
  return /* @__PURE__ */React15.createElement(UitkCheckboxGroup, {
    group: groupName,
    errorMessage: errorMessage || void 0,
    legendLabel: legend
  }, options.map(function (option, index) {
    return /* @__PURE__ */React15.createElement(EGDSCheckBox, {
      checked: state.values.includes(option.name || ""),
      required: data.required ? state.values.length === 0 : void 0,
      data: option,
      key: "".concat(option.name, "_").concat(index),
      onChange: handleCheckChange
    });
  }));
};
DirectFeedbackMultiSelectGroup.fragment = fragment19;
DirectFeedbackMultiSelectGroup.displayName = "DirectFeedbackMultiSelectGroup";
// src/components/direct-feedback/__private/__fragments/direct-feedback-radio-group.tsx
import React16, { useCallback as useCallback3, useState as useState3 } from "react";
import { gql as gql20 } from "@apollo/client";
import { UitkRadioButton, UitkRadioButtonGroup } from "uitk-react-radio-button";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
var fragment20 = gql20(_templateObject19());
var DirectFeedbackRadioGroup = function (param) {
  var data = param.data,
    onChange = param.onChange,
    value = param.value;
  var groupName = data.groupName,
    errorMessage = data.errorMessage,
    options = data.radioGroupOptions,
    required = data.required,
    legend = data.legend;
  var _useState3 = _sliced_to_array(useState3({
      value: value || data.selected || void 0
    }), 2),
    state = _useState3[0],
    setState = _useState3[1];
  var handleRadioChange = useCallback3(function (event) {
    var newState = {
      value: event.currentTarget.value
    };
    setState(newState);
    if (onChange) {
      onChange(groupName, newState.value, !required || !!newState.value);
    }
  }, [onChange, groupName, required]);
  return /* @__PURE__ */React16.createElement(UitkRadioButtonGroup, {
    group: groupName,
    errorMessage: errorMessage || void 0,
    selected: state.value,
    onChange: handleRadioChange,
    legendLabel: legend
  }, options.map(function (option, index) {
    return /* @__PURE__ */React16.createElement(UitkSpacing2, {
      key: "".concat(groupName, "_option").concat(index),
      margin: {
        blockend: "two"
      }
    }, /* @__PURE__ */React16.createElement("div", null, /* @__PURE__ */React16.createElement(UitkRadioButton, {
      id: option.value || "".concat(groupName, "_option").concat(index),
      value: option.value || "".concat(groupName, "_option").concat(index),
      labelSuffix: option.labelSuffix || void 0,
      description: option.description || void 0
    }, option.label)));
  }));
};
DirectFeedbackRadioGroup.fragment = fragment20;
DirectFeedbackRadioGroup.displayName = "DirectFeedbackRadioGroup";
// src/components/direct-feedback/__private/__fragments/direct-feedback-text-area.tsx
import React17, { useCallback as useCallback4, useMemo as useMemo4, useState as useState4 } from "react";
import { gql as gql21 } from "@apollo/client";
import { UitkTextArea } from "uitk-react-input";
var fragment21 = gql21(_templateObject20(), fragment16, EGDSIcon.fragment);
var idIncrementor3 = 0;
var DirectFeedbackTextArea = function (props) {
  var _props_data = props.data,
    isEditable = _props_data.isEditable,
    label = _props_data.label,
    maxRows = _props_data.maxRows,
    minRows = _props_data.minRows,
    placeholder = _props_data.placeholder,
    dataValue = _props_data.value,
    name = _props_data.name,
    required = _props_data.required,
    validations = _props_data.validations,
    onChange = props.onChange,
    value = props.value;
  var id = useMemo4(function () {
    idIncrementor3 += 1;
    return idIncrementor3;
  }, []);
  var validator = useMemo4(function () {
    return getValidator(validations);
  }, [validations]);
  var _useState4 = _sliced_to_array(useState4(void 0), 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var handleChange = useCallback4(function (e) {
    if (onChange) {
      var error = validator.validate(e.target.value).invalid;
      setErrorMessage(error);
      onChange(e.target.name, e.target.value, error === void 0 && (!required || !!e.target.value));
    }
  }, [onChange, required, validator]);
  return /* @__PURE__ */React17.createElement(UitkTextArea, {
    id: "uitk-text-area-".concat(name, "-").concat(id),
    label: label || "",
    value: value || dataValue || void 0,
    name: name || void 0,
    disabled: !isEditable,
    hasVisibleLabel: label !== "",
    maxRows: maxRows || void 0,
    minRows: minRows || void 0,
    placeholder: placeholder || void 0,
    onChange: handleChange,
    required: required || false,
    invalid: errorMessage
  });
};
DirectFeedbackTextArea.fragment = fragment21;
DirectFeedbackTextArea.displayName = "DirectFeedbackTextArea";
// src/components/direct-feedback/__private/__fragments/direct-feedback-element.tsx
var fragment22 = gql22(_templateObject21(), EGDSErrorSummary.fragment, EGDSPlainText.fragment, EGDSHeading.fragment, DirectFeedbackMultiSelectGroup.fragment, EGDSSpannableText.fragment, DirectFeedbackRadioGroup.fragment, DirectFeedbackInputField.fragment, DirectFeedbackTextArea.fragment, DirectFeedbackTextList.fragment);
var EgdsInputComponentLookup = {
  DirectFeedbackMultiSelectGroup: DirectFeedbackMultiSelectGroup,
  DirectFeedbackRadioGroup: DirectFeedbackRadioGroup,
  DirectFeedbackInputField: DirectFeedbackInputField,
  DirectFeedbackTextArea: DirectFeedbackTextArea
};
var EgdsInputValueLookupFn = {
  DirectFeedbackMultiSelectGroup: function DirectFeedbackMultiSelectGroup(data, values) {
    return values.get(data.groupName);
  },
  DirectFeedbackRadioGroup: function DirectFeedbackRadioGroup(data, values) {
    return values.get(data.groupName);
  },
  DirectFeedbackInputField: function DirectFeedbackInputField(data, values) {
    return data.name ? values.get(data.name) : null;
  },
  DirectFeedbackTextArea: function DirectFeedbackTextArea(data, values) {
    return data.name ? values.get(data.name) : null;
  }
};
function isDisplayElement(data) {
  return !!DirectFeedbackDisplayElement.supportedTypes.find(function (typeName) {
    return data.__typename === typeName;
  });
}
var DirectFeedbackElement = function (props) {
  var data = props.data,
    onChange = props.onChange,
    values = props.values;
  var InputComponentImplementation = EgdsInputComponentLookup[data.__typename];
  var onChangeHandler = useCallback5(function (name, value, isValid) {
    var _onChange;
    (_onChange = onChange) === null || _onChange === void 0 ? void 0 : _onChange(name, value, isValid);
  }, [onChange]);
  if (InputComponentImplementation) {
    var ValueLookup = EgdsInputValueLookupFn[data.__typename];
    return ValueLookup ? /* @__PURE__ */React18.createElement(InputComponentImplementation, {
      data: data,
      value: ValueLookup(data, values),
      onChange: onChangeHandler
    }) : null;
  }
  if (isDisplayElement(data)) {
    return /* @__PURE__ */React18.createElement(DirectFeedbackDisplayElement, {
      data: data
    });
  }
  return /* @__PURE__ */React18.createElement("pre", null, JSON.stringify(data, null, 2));
};
DirectFeedbackElement.fragment = fragment22;
DirectFeedbackElement.displayName = "DirectFeedbackElement";
// src/components/direct-feedback/__private/__fragments/egds-button.tsx
import React21, { useCallback as useCallback8 } from "react";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
// src/components/direct-feedback/__private/__fragments/egds-button-fragment.tsx
import { gql as gql23 } from "@apollo/client";
var fragment23 = gql23(_templateObject22());
// src/components/direct-feedback/__private/__fragments/ui-primary-button.tsx
import React19, { useCallback as useCallback6 } from "react";
import { gql as gql24 } from "@apollo/client";
import { UitkPrimaryButton } from "uitk-react-button";
var fragment24 = gql24(_templateObject23(), fragment23);
var UIPrimaryButton = function ActionComponentFactory() {
  var UIPrimaryButtonRender = function UIPrimaryButtonRender(param) {
    var actionDispatch = param.actionDispatch,
      _param_buttonProps = param.buttonProps,
      buttonProps = _param_buttonProps === void 0 ? {} : _param_buttonProps,
      data = param.data;
    var action = data.action;
    var onClick = buttonProps.onClick;
    var onClickHandler = useCallback6(function (evt) {
      if (actionDispatch && action) {
        actionDispatch(action);
      }
      if (onClick) {
        onClick(evt);
      }
    }, [actionDispatch, action, onClick]);
    return /* @__PURE__ */React19.createElement(UitkPrimaryButton, _object_spread_props(_object_spread({
      type: "button",
      disabled: data.disabled
    }, buttonProps), {
      onClick: onClickHandler
    }), data.primary, " ", data.icon && /* @__PURE__ */React19.createElement(EGDSIcon, {
      data: data.icon
    }));
  };
  UIPrimaryButtonRender.displayName = "UIPrimaryButton";
  UIPrimaryButtonRender.fragment = fragment24;
  return UIPrimaryButtonRender;
}();
// src/components/direct-feedback/__private/__fragments/ui-secondary-button.tsx
import React20, { useCallback as useCallback7 } from "react";
import { gql as gql25 } from "@apollo/client";
import { UitkSecondaryButton } from "uitk-react-button";
var fragment25 = gql25(_templateObject24(), fragment23);
var UISecondaryButton = function ActionComponentFactory2() {
  var UISecondaryButtonRender = function UISecondaryButtonRender(param) {
    var actionDispatch = param.actionDispatch,
      _param_buttonProps = param.buttonProps,
      buttonProps = _param_buttonProps === void 0 ? {} : _param_buttonProps,
      data = param.data;
    var action = data.action;
    var onClick = buttonProps.onClick;
    var onClickHandler = useCallback7(function (evt) {
      if (actionDispatch && action) {
        actionDispatch(action);
      }
      if (onClick) {
        onClick(evt);
      }
    }, [actionDispatch, action, onClick]);
    return /* @__PURE__ */React20.createElement(UitkSecondaryButton, _object_spread_props(_object_spread({
      type: "button"
    }, buttonProps), {
      onClick: onClickHandler,
      disabled: data.disabled
    }), data.primary, " ", data.icon && /* @__PURE__ */React20.createElement(EGDSIcon, {
      data: data.icon
    }));
  };
  UISecondaryButtonRender.displayName = "UISecondaryButton";
  UISecondaryButtonRender.fragment = fragment25;
  return UISecondaryButtonRender;
}();
// src/components/direct-feedback/__private/__fragments/egds-button.tsx
var EGDSButtonConcreteTypeLookup = {
  UIPrimaryButton: UIPrimaryButton,
  UISecondaryButton: UISecondaryButton
};
var EGDSButton = function ActionComponentFactory3() {
  var EGDSButtonRender = function EGDSButtonRender(param) {
    var actionDispatch = param.actionDispatch,
      buttonProps = param.buttonProps,
      data = param.data;
    var Component = EGDSButtonConcreteTypeLookup[data.__typename] || UISecondaryButton;
    var analytics = data.analytics;
    var track = useClickTracker2();
    var uitkButtonProps = _object_spread({}, buttonProps);
    var onClick = uitkButtonProps.onClick;
    uitkButtonProps.onClick = useCallback8(function (evt) {
      if (analytics) {
        track("".concat(analytics.referrerId), analytics.linkName, false);
      }
      if (onClick) {
        onClick(evt);
      }
    }, [analytics, track, onClick]);
    return /* @__PURE__ */React21.createElement(Component, {
      data: data,
      buttonProps: uitkButtonProps,
      actionDispatch: actionDispatch
    });
  };
  EGDSButtonRender.displayName = "EGDSButton";
  EGDSButtonRender.fragment = fragment23;
  return EGDSButtonRender;
}();
// src/components/direct-feedback/__private/__fragments/direct-feedback-page.tsx
var fragment26 = gql26(_templateObject25(), DirectFeedbackElement.fragment, DirectFeedbackDisplayElement.fragment, EGDSButton.fragment, EGDSText.fragment);
var DirectFeedbackPage = function (param) {
  var data = param.data,
    eventDispatch = param.eventDispatch,
    values = param.values,
    valuesValidation = param.valuesValidation;
  var _data_elements, _data_subtitle, _data_elements1, _data_commands, _data_footer;
  var dispatchLookup = useMemo5(function () {
    return {
      DirectFeedbackOpenNextPageAction: function (action) {
        if (eventDispatch) {
          eventDispatch(new DirectFeedbackNextCommand(action));
        }
      },
      DirectFeedbackOpenPreviousPageAction: function (action) {
        if (eventDispatch) {
          eventDispatch(new DirectFeedbackPreviousCommand(action));
        }
      },
      DirectFeedbackSubmitFormAction: function (action) {
        if (eventDispatch) {
          eventDispatch(new DirectFeedbackSubmitCommand(action));
        }
      }
    };
  }, [eventDispatch]);
  var onChange = useCallback9(function (name, value, isValid2) {
    if (eventDispatch) {
      eventDispatch(new DirectFeedbackSetValueCommand(name, value, isValid2));
    }
  }, [eventDispatch]);
  var isValid = (_data_elements = data.elements) === null || _data_elements === void 0 ? void 0 : _data_elements.filter(function (element) {
    return "name" in element || "groupName" in element;
  }).map(function (element) {
    if ("name" in element) {
      return element.name;
    }
    return element.groupName;
  }).reduce(function (aggregate, fieldId) {
    return aggregate && (!valuesValidation.has(fieldId) || valuesValidation.get(fieldId));
  }, true);
  return /* @__PURE__ */React22.createElement(UitkSpacing3, {
    margin: "two"
  }, /* @__PURE__ */React22.createElement(UitkForm, {
    hasRequiredFieldIndicator: true
  }, /* @__PURE__ */React22.createElement(UitkLayoutFlex2, {
    space: "four",
    direction: "column"
  }, (data.title || ((_data_subtitle = data.subtitle) === null || _data_subtitle === void 0 ? void 0 : _data_subtitle.text)) && /* @__PURE__ */React22.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */React22.createElement("div", null, data.title && /* @__PURE__ */React22.createElement(UitkHeading2, {
    tag: "h3",
    size: 4
  }, data.title), data.subtitle && /* @__PURE__ */React22.createElement(UitkSubheading, null, data.subtitle.text))), ((_data_elements1 = data.elements) === null || _data_elements1 === void 0 ? void 0 : _data_elements1.length) ? data.elements.map(function (element, index) {
    return /* @__PURE__ */React22.createElement(UitkLayoutFlexItem2, {
      key: "".concat(element.__typename, "_").concat(index)
    }, /* @__PURE__ */React22.createElement("div", null, /* @__PURE__ */React22.createElement(DirectFeedbackElement, {
      data: element,
      values: values,
      onChange: onChange
    })));
  }) : null, ((_data_commands = data.commands) === null || _data_commands === void 0 ? void 0 : _data_commands.length) ? /* @__PURE__ */React22.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */React22.createElement(UitkSpacing3, {
    margin: {
      blockstart: "four",
      blockend: "four"
    }
  }, /* @__PURE__ */React22.createElement(UitkLayoutFlex2, {
    justifyContent: "space-between"
  }, data.commands.map(function (command, index) {
    var _command_action, _command;
    var actionType = ((_command = command) === null || _command === void 0 ? void 0 : (_command_action = _command.action) === null || _command_action === void 0 ? void 0 : _command_action.__typename) || "";
    var actionDispatch = dispatchLookup[actionType];
    var disabled = (actionType === "DirectFeedbackOpenNextPageAction" || actionType === "DirectFeedbackSubmitFormAction") && !isValid;
    return /* @__PURE__ */React22.createElement(UitkLayoutFlexItem2, {
      key: "EGDSButton_".concat(index)
    }, /* @__PURE__ */React22.createElement(EGDSButton, {
      data: command,
      actionDispatch: actionDispatch,
      buttonProps: {
        disabled: disabled
      }
    }));
  })))) : null, ((_data_footer = data.footer) === null || _data_footer === void 0 ? void 0 : _data_footer.length) ? data.footer.map(function (element, index) {
    return /* @__PURE__ */React22.createElement(UitkLayoutFlexItem2, {
      key: "".concat(element.__typename, "_").concat(index)
    }, /* @__PURE__ */React22.createElement("div", null, /* @__PURE__ */React22.createElement(DirectFeedbackDisplayElement, {
      data: element
    })));
  }) : null)));
};
DirectFeedbackPage.fragment = fragment26;
DirectFeedbackPage.displayName = "DirectFeedbackPage";
// src/components/direct-feedback/__private/__fragments/direct-feedback-pages.tsx
var fragment27 = gql27(_templateObject26(), DirectFeedbackPage.fragment);
var getInitialState = function (pages) {
  var requiredElements = pages.flatMap(function (page) {
    return page.elements;
  }).filter(function (element) {
    return "name" in element || "groupName" in element;
  }).filter(function (element) {
    return "required" in element && element.required;
  }).map(function (element) {
    if ("name" in element) {
      return element.name;
    }
    return element.groupName;
  });
  var recordValidation = /* @__PURE__ */new Map();
  requiredElements.forEach(function (fieldId) {
    recordValidation.set(fieldId, false);
  });
  return {
    pageIndexStack: [0],
    numPages: pages.length,
    record: /* @__PURE__ */new Map(),
    recordValidation: recordValidation
  };
};
var isPageValid = function (page, record) {
  return page.displayConditions ? page.displayConditions.every(function (condition) {
    var fieldValue = record.get(condition.fieldId);
    var isValid;
    switch (condition.conditionType) {
      case "BOOL" /* BOOL */:
        isValid = condition.expectedValue === fieldValue;
        break;
      case "PATTERN" /* PATTERN */:
        isValid = new RegExp(condition.expectedValue).test(fieldValue);
        break;
      case "TEXT" /* TEXT */:
        isValid = condition.expectedValue === fieldValue;
        break;
      case "NONE" /* NONE */:
        isValid = true;
        break;
      default:
        isValid = true;
        break;
    }
    return isValid;
  }) : true;
};
var getNextPageIndex = function (pages, state) {
  var a = state.pageIndexStack[state.pageIndexStack.length - 1];
  var possiblePages = pages.slice((state.pageIndexStack[state.pageIndexStack.length - 1] || 0) + 1);
  var nextPageIndex = -1;
  var possiblePagesIndex = possiblePages.findIndex(function (page) {
    return isPageValid(page, state.record);
  });
  if (possiblePagesIndex >= 0) {
    nextPageIndex = possiblePagesIndex + 1 + (state.pageIndexStack[state.pageIndexStack.length - 1] || 0);
  } else {
    nextPageIndex = pages.length;
  }
  return nextPageIndex;
};
var DirectFeedbackPages = function (param) {
  var data = param.data,
    doSubmit = param.doSubmit,
    doClose = param.doClose,
    doFormValueChanged = param.doFormValueChanged;
  var pages = data.pages;
  var pagesStateReducer = useCallback10(function (state2, action) {
    var newState = {
      pageIndexStack: state2.pageIndexStack.slice(0),
      numPages: state2.numPages,
      record: new Map(state2.record),
      recordValidation: new Map(state2.recordValidation)
    };
    var setter;
    var goto;
    switch (action.type) {
      case 0 /* Submit */:
        newState.pageIndexStack.push(getNextPageIndex(pages, state2));
        break;
      case 2 /* Next */:
        goto = action;
        if (goto.action.destinationId) {
          var nextPageIndex = pages.findIndex(function (page2) {
            return page2.id === goto.action.destinationId;
          });
          newState.pageIndexStack.push(nextPageIndex);
        } else {
          newState.pageIndexStack.push(getNextPageIndex(pages, state2));
        }
        break;
      case 1 /* Previous */:
        if (newState.pageIndexStack.length > 1) {
          newState.pageIndexStack.pop();
        }
        break;
      case 3 /* SetValue */:
        setter = action;
        newState.record.set(setter.fieldId, setter.value);
        newState.recordValidation.set(setter.fieldId, setter.isValid);
        break;
      default:
        break;
    }
    return newState;
  }, [pages]);
  var _useReducer = _sliced_to_array(useReducer(pagesStateReducer, pages, getInitialState), 2),
    state = _useReducer[0],
    dispatch = _useReducer[1];
  var _useState5 = _sliced_to_array(useState5(false), 2),
    submitting = _useState5[0],
    setSubmitting = _useState5[1];
  var pageEventHandler = useCallback10(function (action) {
    switch (action.type) {
      case 0 /* Submit */:
        if (doSubmit) {
          setSubmitting(true);
          doSubmit(Array.from(state.record.keys()).map(function (key) {
            var _state_record_get;
            return {
              key: key,
              value: (_state_record_get = state.record.get(key)) === null || _state_record_get === void 0 ? void 0 : _state_record_get.toString()
            };
          })).then(function () {
            dispatch(action);
            setSubmitting(false);
          }).catch(/* istanbul ignore next */function () {
            setSubmitting(false);
          });
        }
        break;
      case 3 /* SetValue */:
        if (doFormValueChanged) {
          var actionData = action;
          doFormValueChanged(actionData);
        }
        dispatch(action);
        break;
      default:
        dispatch(action);
        break;
    }
  }, [dispatch, doSubmit, state, setSubmitting]);
  useEffect(function () {
    if ((state.pageIndexStack[state.pageIndexStack.length - 1] || 0) >= state.numPages && doClose) {
      doClose();
    }
  });
  var pageIndex = state.pageIndexStack[state.pageIndexStack.length - 1] || 0;
  var page = pages[pageIndex];
  if (submitting) {
    return /* @__PURE__ */React23.createElement(LoadingContent, null);
  }
  if (pageIndex < state.numPages && page) {
    return /* @__PURE__ */React23.createElement(DirectFeedbackPage, {
      data: page,
      eventDispatch: pageEventHandler,
      values: state.record,
      valuesValidation: state.recordValidation
    });
  }
  return null;
};
DirectFeedbackPages.fragment = fragment27;
DirectFeedbackPages.displayName = "DirectFeedbackPages";
// src/components/direct-feedback/arkose.tsx
import React24 from "react";
var Arkose = /*#__PURE__*/function (_React24_Component) {
  "use strict";

  _inherits(Arkose, _React24_Component);
  var _super = _create_super(Arkose);
  function Arkose(props) {
    _class_call_check(this, Arkose);
    var _this;
    _this = _super.call(this, props);
    __publicField(_assert_this_initialized(_this), "myEnforcement");
    __publicField(_assert_this_initialized(_this), "scriptId");
    __publicField(_assert_this_initialized(_this), "removeScript", function () {
      var currentScript = document.getElementById(_this.scriptId);
      if (currentScript) {
        currentScript.remove();
      }
    });
    // Append the JS tag to the Document Body.
    __publicField(_assert_this_initialized(_this), "loadScript", function () {
      _this.removeScript();
      var script = document.createElement("script");
      script.id = _this.scriptId;
      script.type = "text/javascript";
      script.src = _this.props.clientApiUrl;
      script.setAttribute("data-callback", "setupEnforcement");
      script.async = true;
      script.defer = true;
      if (_this.props.nonce) {
        script.setAttribute("data-nonce", _this.props.nonce);
      }
      document.body.appendChild(script);
      return script;
    });
    __publicField(_assert_this_initialized(_this), "setupEnforcement", function (myEnforcement) {
      _this.myEnforcement = myEnforcement;
      _this.myEnforcement.setConfig({
        selector: _this.props.selector,
        mode: _this.props.mode,
        onReady: _this.props.onReady,
        onShown: _this.props.onShown,
        onShow: _this.props.onShow,
        onSuppress: _this.props.onSuppress,
        onCompleted: _this.props.onCompleted,
        onReset: _this.props.onReset,
        onHide: _this.props.onHide,
        onError: _this.props.onError,
        onFailed: _this.props.onFailed
      });
    });
    _this.myEnforcement = null;
    _this.scriptId = "";
    return _this;
  }
  _create_class(Arkose, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;
      this.scriptId = "arkose-script-".concat(this.props.publicKey);
      var scriptElement = this.loadScript();
      scriptElement.onload = function () {
        window.setupEnforcement = _this.setupEnforcement.bind(_this);
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (this.myEnforcement) {
        this.setupEnforcement(this.myEnforcement);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (window.setupEnforcement) {
        delete window.setupEnforcement;
      }
      this.removeScript();
    }
  }, {
    key: "render",
    value: function render() {
      var _this_props_selector, _this_props;
      return /* @__PURE__ */React24.createElement(React24.Fragment, null, this.props.mode === "inline" && /* @__PURE__ */React24.createElement("div", {
        id: (_this_props = this.props) === null || _this_props === void 0 ? void 0 : (_this_props_selector = _this_props.selector) === null || _this_props_selector === void 0 ? void 0 : _this_props_selector.slice(1)
      }));
    }
  }]);
  return Arkose;
}(React24.Component);
// src/components/direct-feedback/direct-feedback-prompt.tsx
var __Query = gql28(_templateObject27(), DirectFeedbackPages.fragment);
var __SubmitFeedbackMutation = gql28(_templateObject28());
var PromptContent = function (param) {
  var data = param.data,
    mutationErrors = param.mutationErrors,
    doSubmit = param.doSubmit,
    doClose = param.doClose,
    doFormValueChanged = param.doFormValueChanged;
  return /* @__PURE__ */React25.createElement(UitkLayoutGrid, {
    space: "two"
  }, mutationErrors && mutationErrors.length > 0 ? mutationErrors.map(function (error, index) {
    return /* @__PURE__ */React25.createElement(UitkLayoutGridItem, {
      key: "UitkErrorSummary_".concat(index)
    }, /* @__PURE__ */React25.createElement(UitkErrorSummary2, {
      heading: "",
      description: error.error
    }));
  }) : null, /* @__PURE__ */React25.createElement(UitkLayoutGridItem, null, /* @__PURE__ */React25.createElement(DirectFeedbackPages, {
    data: data,
    doClose: doClose,
    doSubmit: doSubmit,
    doFormValueChanged: doFormValueChanged
  })));
};
var ErrorContent = function (param) {
  var error = param.error;
  var _error;
  return /* @__PURE__ */React25.createElement(UitkErrorSummary2, {
    heading: ((_error = error) === null || _error === void 0 ? void 0 : _error.message) || ""
  });
};
var DirectFeedbackPrompt = function (props) {
  var _data_directFeedbackPromptById, _data, _data_directFeedbackPromptById1, _data1, _inputs, _data2;
  var inputs = props.inputs,
    eventDispatch = props.eventDispatch,
    contextValues = props.contextValues;
  var context = useBexApi().context;
  var promptId = inputs.promptId;
  var filteredContextValues = useMemo6(function () {
    return (contextValues !== null && contextValues !== void 0 ? contextValues : []).map(function (value) {
      return {
        key: value.key,
        value: value.value
      };
    });
  }, [contextValues]);
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useMutation = _sliced_to_array(useMutation(__SubmitFeedbackMutation), 2),
    submit = _useMutation[0],
    _useMutation_ = _useMutation[1],
    mutationData = _useMutation_.data,
    mutationLoading = _useMutation_.loading,
    mutationError = _useMutation_.error;
  var doEventDispatch = useCallback11(function (event) {
    if (eventDispatch) {
      setTimeout(function () {
        return eventDispatch(event);
      });
    }
  }, [eventDispatch]);
  var emitOnError = useCallback11(function (eventError) {
    doEventDispatch(new DirectFeedbackErrorEvent(promptId, eventError));
  }, [promptId, doEventDispatch]);
  var emitOnLoad = useCallback11(function (data2) {
    if (data2.directFeedbackPromptById) {
      doEventDispatch(new DirectFeedbackLoadEvent(promptId, data2.directFeedbackPromptById));
    }
  }, [promptId, doEventDispatch]);
  var _useQuery = useQuery(__Query, {
      variables: variables,
      onError: emitOnError,
      onCompleted: emitOnLoad
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  var captchaInfo;
  if (((_data = data) === null || _data === void 0 ? void 0 : (_data_directFeedbackPromptById = _data.directFeedbackPromptById) === null || _data_directFeedbackPromptById === void 0 ? void 0 : _data_directFeedbackPromptById.challenges) && ((_data1 = data) === null || _data1 === void 0 ? void 0 : (_data_directFeedbackPromptById1 = _data1.directFeedbackPromptById) === null || _data_directFeedbackPromptById1 === void 0 ? void 0 : _data_directFeedbackPromptById1.challenges.length) > 0) {
    var _data_directFeedbackPromptById_challenges_, _data_directFeedbackPromptById2, _data3;
    captchaInfo = (_data3 = data) === null || _data3 === void 0 ? void 0 : (_data_directFeedbackPromptById2 = _data3.directFeedbackPromptById) === null || _data_directFeedbackPromptById2 === void 0 ? void 0 : (_data_directFeedbackPromptById_challenges_ = _data_directFeedbackPromptById2.challenges[0]) === null || _data_directFeedbackPromptById_challenges_ === void 0 ? void 0 : _data_directFeedbackPromptById_challenges_.action;
  }
  var arkoseRef = useRef(null);
  var _useState6 = _sliced_to_array(useState6(), 2),
    arkosePromise = _useState6[0],
    setArkosePromise = _useState6[1];
  var _useState61 = _sliced_to_array(useState6(), 2),
    resolveArkose = _useState61[0],
    setResolveArkose = _useState61[1];
  var _useState62 = _sliced_to_array(useState6(), 2),
    rejectArkose = _useState62[0],
    setRejectArkose = _useState62[1];
  var buildArkosePromise = useCallback11(function () {
    var newArkosePromise = new Promise(function (resolve, reject) {
      setRejectArkose(function () {
        return reject;
      });
      setResolveArkose(function () {
        return resolve;
      });
    });
    setArkosePromise(newArkosePromise);
  }, [setArkosePromise, setResolveArkose, setRejectArkose]);
  var onArkoseHide = useCallback11(function () {
    if (rejectArkose) {
      rejectArkose();
    }
    buildArkosePromise();
  }, [rejectArkose, buildArkosePromise]);
  useEffect2(function () {
    buildArkosePromise();
  }, [buildArkosePromise]);
  var doSubmit = useCallback11(function (formValues, arkoseToken) {
    var _inputs;
    var atoShieldValidation = arkoseToken ? {
      captchaToken: arkoseToken
    } : void 0;
    return submit({
      variables: {
        context: context,
        feedback: {
          formValues: formValues,
          context: filteredContextValues,
          atoShieldValidation: atoShieldValidation
        },
        id: (_inputs = inputs) === null || _inputs === void 0 ? void 0 : _inputs.promptId
      }
    }).then(function () {
      if (eventDispatch) {
        eventDispatch(new DirectFeedbackSubmitEvent(promptId, filteredContextValues, formValues));
      }
    });
  }, [promptId, eventDispatch, submit, filteredContextValues, context, (_inputs = inputs) === null || _inputs === void 0 ? void 0 : _inputs.promptId]);
  var submitIfNeeded = useCallback11(function (formValues) {
    if (captchaInfo && arkoseRef.current && arkosePromise) {
      var _arkoseRef_current_myEnforcement;
      (_arkoseRef_current_myEnforcement = arkoseRef.current.myEnforcement) === null || _arkoseRef_current_myEnforcement === void 0 ? void 0 : _arkoseRef_current_myEnforcement.run();
      return arkosePromise.then(function (response) {
        return doSubmit(formValues, response.token);
      });
    }
    return doSubmit(formValues);
  }, [arkoseRef, arkosePromise, captchaInfo, doSubmit]);
  var emitOnClose = useCallback11(function () {
    if (eventDispatch) {
      eventDispatch(new DirectFeedbackCloseEvent(promptId));
    }
  }, [promptId, eventDispatch]);
  var emitFormValueChanged = useCallback11(function (action) {
    if (eventDispatch) {
      eventDispatch(new DirectFeedbackFormValueChanged(promptId, action.fieldId, action.value));
    }
  }, [promptId, eventDispatch]);
  var content;
  if (loading) {
    content = /* @__PURE__ */React25.createElement(LoadingContent, null);
  } else if ((_data2 = data) === null || _data2 === void 0 ? void 0 : _data2.directFeedbackPromptById) {
    var _mutationData;
    content = /* @__PURE__ */React25.createElement(React25.Fragment, null, /* @__PURE__ */React25.createElement(PromptContent, {
      data: data.directFeedbackPromptById,
      mutationErrors: ((_mutationData = mutationData) === null || _mutationData === void 0 ? void 0 : _mutationData.directFeedbackSubmit.errors) || [],
      doSubmit: submitIfNeeded,
      doClose: emitOnClose,
      doFormValueChanged: emitFormValueChanged
    }), captchaInfo && /* @__PURE__ */React25.createElement(Arkose, {
      publicKey: captchaInfo.apiKey,
      clientApiUrl: captchaInfo.src,
      onCompleted: resolveArkose,
      onHide: onArkoseHide,
      ref: arkoseRef
    }));
  } else {
    content = /* @__PURE__ */React25.createElement(ErrorContent, {
      error: error
    });
  }
  return content;
};
DirectFeedbackPrompt.displayName = "sharedui-DirectFeedbackPrompt";
// src/components/direct-feedback/direct-feedback-dialog.tsx
var DirectFeedbackDialog = function (props) {
  var inputs = props.inputs,
    eventDispatch = props.eventDispatch,
    contextValues = props.contextValues,
    triggerRef = props.triggerRef,
    dialogQueryId = props.dialogQueryId;
  var formatText = useLocalization().formatText;
  var promptId = inputs.promptId;
  var dialogQueryKey = "cdfPromptDialog";
  var ref = React26.useRef(null);
  var _useDialog = _sliced_to_array(useDialog(dialogQueryId || promptId, dialogQueryKey), 3),
    dialogActions = _useDialog[1],
    DialogWrapper = _useDialog[2];
  var _useState7 = _sliced_to_array(useState7(""), 2),
    toolbarTitle = _useState7[0],
    setToolbarTitle = _useState7[1];
  var closeDialog = dialogActions.closeDialog;
  var track = useClickTracker3();
  var onNavigationClick = useCallback12(function (id, description, event) {
    track(id, "Direct feedback prompt close", false);
  }, [track]);
  var directFeedbackEventHandler = useCallback12(function (event) {
    switch (event.type) {
      case 1 /* Close */:
        closeDialog();
        break;
      case 3 /* Load */:
        var _event_data;
        setToolbarTitle(((_event_data = event.data) === null || _event_data === void 0 ? void 0 : _event_data.title) || "");
        break;
      default:
        break;
    }
    if (eventDispatch) {
      setTimeout(function () {
        return eventDispatch(event);
      });
    }
  }, [closeDialog, eventDispatch]);
  var emitOnClose = useCallback12(function () {
    if (eventDispatch) {
      eventDispatch(new DirectFeedbackCloseEvent(promptId));
    }
  }, [promptId, eventDispatch]);
  var handleToolbarClick = useCallback12(function () {
    dialogActions.closeDialog();
  }, [dialogActions]);
  var _formatText, _formatText1;
  return /* @__PURE__ */React26.createElement(UitkSheetTransition, {
    isVisible: true,
    closeCallback: emitOnClose
  }, /* @__PURE__ */React26.createElement(DialogWrapper, null, /* @__PURE__ */React26.createElement(Viewport, null, /* @__PURE__ */React26.createElement(ViewSmall, null, /* @__PURE__ */React26.createElement(UitkSheet, {
    isVisible: true,
    closeCallback: emitOnClose,
    triggerRef: triggerRef || ref,
    type: "full",
    returnFocusOnClose: true
  }, /* @__PURE__ */React26.createElement(UitkToolbar, {
    navigationContent: {
      onClick: handleToolbarClick,
      navType: "close",
      navIconLabel: (_formatText = formatText("close.dialog")) !== null && _formatText !== void 0 ? _formatText : "Close",
      onClickAnalytics: {
        id: "DirectFeedback.".concat(promptId, ".dialog"),
        callback: onNavigationClick
      }
    },
    toolbarTitle: toolbarTitle
  }), /* @__PURE__ */React26.createElement(UitkSheetContent, null, /* @__PURE__ */React26.createElement(DirectFeedbackPrompt, {
    inputs: inputs,
    eventDispatch: directFeedbackEventHandler,
    contextValues: contextValues
  })))), /* @__PURE__ */React26.createElement(ViewLarge, null, /* @__PURE__ */React26.createElement(UitkSheet, {
    isVisible: true,
    closeCallback: emitOnClose,
    triggerRef: ref,
    type: "centered",
    returnFocusOnClose: true
  }, /* @__PURE__ */React26.createElement(UitkToolbar, {
    navigationContent: {
      onClick: handleToolbarClick,
      navType: "close",
      navIconLabel: (_formatText1 = formatText("close.dialog")) !== null && _formatText1 !== void 0 ? _formatText1 : "Close",
      onClickAnalytics: {
        id: "DirectFeedback.".concat(promptId, ".dialog"),
        callback: onNavigationClick
      }
    },
    toolbarTitle: toolbarTitle
  }), /* @__PURE__ */React26.createElement(UitkSheetContent, null, /* @__PURE__ */React26.createElement(DirectFeedbackPrompt, {
    inputs: inputs,
    eventDispatch: directFeedbackEventHandler,
    contextValues: contextValues
  })))))));
};
DirectFeedbackDialog.displayName = "sharedui-DirectFeedbackDialog";
// src/components/direct-feedback/direct-feedback-call-to-action.tsx
import React35, { useCallback as useCallback15, useEffect as useEffect3, useState as useState8 } from "react";
import { gql as gql31, useMutation as useMutation2, useQuery as useQuery2 } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
// src/components/direct-feedback/__private/__fragments/adapters/direct-feedback-call-to-action-image-link-adapter.tsx
import React28 from "react";
// src/components/direct-feedback/__private/__fragments/egds-image-link.tsx
import React27, { useCallback as useCallback13 } from "react";
import { gql as gql29 } from "@apollo/client";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { UitkFigure, UitkFigureAspectRatioType, UitkImage, UitkImageLink } from "uitk-react-images";
var fragment28 = gql29(_templateObject29());
var _obj4;
var aspectRatioMapper = (_obj4 = {}, _define_property(_obj4, "ONE_ONE" /* ONE_ONE */, UitkFigureAspectRatioType.R1_1), _define_property(_obj4, "FOUR_ONE" /* FOUR_ONE */, UitkFigureAspectRatioType.R4_1), _define_property(_obj4, "FOUR_THREE" /* FOUR_THREE */, UitkFigureAspectRatioType.R4_3), _define_property(_obj4, "SIXTEEN_NINE" /* SIXTEEN_NINE */, UitkFigureAspectRatioType.R16_9), _define_property(_obj4, "THREE_TWO" /* THREE_TWO */, UitkFigureAspectRatioType.R3_2), _define_property(_obj4, "THREE_FOUR" /* THREE_FOUR */, UitkFigureAspectRatioType.R3_4), _define_property(_obj4, "TWENTY_ONE_NINE" /* TWENTY_ONE_NINE */, UitkFigureAspectRatioType.R21_9), _obj4);
var EGDSImageLink = function (param) {
  var onClick = param.onClick,
    _param_data = param.data,
    _param_data_uiLinkAction = _param_data.uiLinkAction,
    _param_data_uiLinkAction_analytics = _param_data_uiLinkAction.analytics,
    referrerId = _param_data_uiLinkAction_analytics.referrerId,
    linkName = _param_data_uiLinkAction_analytics.linkName,
    image = _param_data.image;
  var track = useClickTracker4();
  var decoratedOnClick = useCallback13(function (event) {
    track(referrerId, linkName);
    if (onClick) {
      onClick(event);
    }
  }, [referrerId, linkName, onClick]);
  return /* @__PURE__ */React27.createElement(UitkFigure, {
    roundcorner: true,
    ratio: image.aspectRatio ? aspectRatioMapper[image.aspectRatio] : UitkFigureAspectRatioType.R16_9
  }, /* @__PURE__ */React27.createElement(UitkImage, {
    placeholderImage: true,
    alt: image.altText || "",
    src: image.url
  }), /* @__PURE__ */React27.createElement(UitkImageLink, null, /* @__PURE__ */React27.createElement("button", {
    type: "button",
    onClick: decoratedOnClick
  }, image.description)));
};
EGDSImageLink.fragment = fragment28;
EGDSImageLink.displayName = "EGDSImageLink";
// src/components/direct-feedback/__private/__fragments/adapters/direct-feedback-call-to-action-image-link-adapter.tsx
var DirectFeedbackCallToActionImageLinkAdapter = function (param) {
  var data = param.data,
    onClick = param.onClick;
  var uiLinkAction = data.uiLinkAction;
  uiLinkAction.resource = {
    __typename: "Uri",
    // eslint-disable-next-line no-script-url
    value: "javascript:void(0)"
  };
  return /* @__PURE__ */React28.createElement(EGDSImageLink, {
    data: data,
    onClick: onClick
  });
};
DirectFeedbackCallToActionImageLinkAdapter.fragment = EGDSImageLink.fragment;
DirectFeedbackCallToActionImageLinkAdapter.displayName = "DirectFeedbackCallToActionImageLinkAdapter";
// src/components/direct-feedback/__private/__fragments/adapters/direct-feedback-call-to-action-inline-link-adapter.tsx
import React29 from "react";
var DirectFeedbackCallToActionInlineLinkAdapter = function (param) {
  var data = param.data,
    onClick = param.onClick;
  var uiLinkAction = data.uiLinkAction;
  uiLinkAction.resource = {
    __typename: "Uri",
    // eslint-disable-next-line no-script-url
    value: "javascript:void(0)"
  };
  return /* @__PURE__ */React29.createElement(EGDSInlineLink, {
    data: data,
    onClick: onClick
  });
};
DirectFeedbackCallToActionInlineLinkAdapter.fragment = EGDSInlineLink.fragment;
DirectFeedbackCallToActionInlineLinkAdapter.displayName = "DirectFeedbackCallToActionInlineLinkAdapter";
// src/components/direct-feedback/__private/__fragments/adapters/direct-feedback-call-to-action-primary-button-adapter.tsx
import React30 from "react";
var DirectFeedbackCallToActionPrimaryButtonAdapter = function (param) {
  var data = param.data,
    onClick = param.onClick;
  return /* @__PURE__ */React30.createElement(UIPrimaryButton, {
    data: data,
    buttonProps: {
      onClick: onClick
    }
  });
};
DirectFeedbackCallToActionPrimaryButtonAdapter.fragment = UIPrimaryButton.fragment;
DirectFeedbackCallToActionPrimaryButtonAdapter.displayName = "DirectFeedbackCallToActionPrimaryButtonAdapter";
// src/components/direct-feedback/__private/__fragments/adapters/direct-feedback-call-to-action-secondary-button-adapter.tsx
import React31 from "react";
var DirectFeedbackCallToActionSecondaryButtonAdapter = function (param) {
  var data = param.data,
    onClick = param.onClick;
  return /* @__PURE__ */React31.createElement(UISecondaryButton, {
    data: data,
    buttonProps: {
      onClick: onClick
    }
  });
};
DirectFeedbackCallToActionSecondaryButtonAdapter.fragment = UISecondaryButton.fragment;
DirectFeedbackCallToActionSecondaryButtonAdapter.displayName = "DirectFeedbackCallToActionSecondaryButtonAdapter";
// src/components/direct-feedback/__private/__fragments/adapters/direct-feedback-call-to-action-standard-link-adapter.tsx
import React32 from "react";
var DirectFeedbackCallToActionStandardLinkAdapter = function (param) {
  var data = param.data,
    onClick = param.onClick;
  var uiLinkAction = data.uiLinkAction;
  uiLinkAction.resource = {
    __typename: "Uri",
    // eslint-disable-next-line no-script-url
    value: "javascript:void(0)"
  };
  return /* @__PURE__ */React32.createElement(EGDSStandardLink, {
    data: data,
    onClick: onClick
  });
};
DirectFeedbackCallToActionStandardLinkAdapter.fragment = EGDSStandardLink.fragment;
DirectFeedbackCallToActionStandardLinkAdapter.displayName = "DirectFeedbackCallToActionStandardLinkAdapter";
// src/components/direct-feedback/__private/__fragments/adapters/direct-feedback-call-to-action-tertiary-button-adapter.tsx
import React34 from "react";
// src/components/direct-feedback/__private/__fragments/ui-tertiary-button.tsx
import React33, { useCallback as useCallback14 } from "react";
import { gql as gql30 } from "@apollo/client";
import { UitkTertiaryButton } from "uitk-react-button";
var fragment29 = gql30(_templateObject30(), fragment23);
var UITertiaryButton = function ActionComponentFactory4() {
  var UITertiaryButtonRender = function UITertiaryButtonRender(param) {
    var actionDispatch = param.actionDispatch,
      _param_buttonProps = param.buttonProps,
      buttonProps = _param_buttonProps === void 0 ? {} : _param_buttonProps,
      data = param.data;
    var action = data.action;
    var onClick = buttonProps.onClick;
    var onClickHandler = useCallback14(function (evt) {
      if (actionDispatch && action) {
        actionDispatch(action);
      }
      if (onClick) {
        onClick(evt);
      }
    }, [actionDispatch, action, onClick]);
    return /* @__PURE__ */React33.createElement(UitkTertiaryButton, _object_spread_props(_object_spread({
      type: "button"
    }, buttonProps), {
      onClick: onClickHandler,
      disabled: data.disabled
    }), data.primary, " ", data.icon && /* @__PURE__ */React33.createElement(EGDSIcon, {
      data: data.icon
    }));
  };
  UITertiaryButtonRender.displayName = "UITertiaryButton";
  UITertiaryButtonRender.fragment = fragment29;
  return UITertiaryButtonRender;
}();
// src/components/direct-feedback/__private/__fragments/adapters/direct-feedback-call-to-action-tertiary-button-adapter.tsx
var DirectFeedbackCallToActionTertiaryButtonAdapter = function (param) {
  var data = param.data,
    onClick = param.onClick;
  return /* @__PURE__ */React34.createElement(UITertiaryButton, {
    data: data,
    buttonProps: {
      onClick: onClick
    }
  });
};
DirectFeedbackCallToActionTertiaryButtonAdapter.fragment = UITertiaryButton.fragment;
DirectFeedbackCallToActionTertiaryButtonAdapter.displayName = "DirectFeedbackCallToActionTertiaryButtonAdapter";
// src/components/direct-feedback/direct-feedback-call-to-action.tsx
var fragment30 = gql31(_templateObject31(), DirectFeedbackCallToActionPrimaryButtonAdapter.fragment, DirectFeedbackCallToActionSecondaryButtonAdapter.fragment, DirectFeedbackCallToActionTertiaryButtonAdapter.fragment, EGDSSpannableText.fragment, DirectFeedbackCallToActionStandardLinkAdapter.fragment, DirectFeedbackCallToActionInlineLinkAdapter.fragment, DirectFeedbackCallToActionImageLinkAdapter.fragment);
var callToActionComponentLookup = function (type) {
  switch (type) {
    case "UIPrimaryButton":
      return DirectFeedbackCallToActionPrimaryButtonAdapter;
    case "UISecondaryButton":
      return DirectFeedbackCallToActionSecondaryButtonAdapter;
    case "UITertiaryButton":
      return DirectFeedbackCallToActionTertiaryButtonAdapter;
    case "EGDSStandardLink":
      return DirectFeedbackCallToActionStandardLinkAdapter;
    case "EGDSInlineLink":
      return DirectFeedbackCallToActionInlineLinkAdapter;
    case "EGDSImageLink":
      return DirectFeedbackCallToActionImageLinkAdapter;
    default:
      throw new Error("unsupported callToAction type. Please update to the newest version of DirectFeedbackCallToAction");
  }
};
function postSubmitComponentLookup(type) {
  switch (type) {
    case "UIPrimaryButton":
      return DirectFeedbackCallToActionPrimaryButtonAdapter;
    case "UISecondaryButton":
      return DirectFeedbackCallToActionSecondaryButtonAdapter;
    case "UITertiaryButton":
      return DirectFeedbackCallToActionTertiaryButtonAdapter;
    case "EGDSStandardLink":
      return DirectFeedbackCallToActionStandardLinkAdapter;
    case "EGDSInlineLink":
      return DirectFeedbackCallToActionInlineLinkAdapter;
    case "EGDSImageLink":
      return DirectFeedbackCallToActionImageLinkAdapter;
    case "EGDSSpannableText":
      return EGDSSpannableText;
    default:
      return null;
  }
}
function cyrb53a(data) {
  var seed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var h1 = 3735928559 ^ seed;
  var h2 = 1103547991 ^ seed;
  for (var i = 0, ch; i < data.length; i++) {
    ch = data.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2246822519);
    h2 = Math.imul(h2 ^ ch, 3266489917);
  }
  h1 ^= Math.imul(h1 ^ h2 >>> 15, 1935289751);
  h2 ^= Math.imul(h2 ^ h1 >>> 15, 3405138345);
  h1 ^= h2 >>> 16;
  h2 ^= h1 >>> 16;
  return 2097152 * (h2 >>> 0) + (h1 >>> 11);
}
var dialogIdCache = /* @__PURE__ */new Map();
function generateDialogId(promptId, contextValues) {
  var baseData = promptId + JSON.stringify(contextValues);
  var counter = 0;
  if (dialogIdCache.has(baseData)) {
    counter = dialogIdCache.get(baseData) || 0;
  }
  dialogIdCache.set(baseData, counter + 1);
  return "".concat(cyrb53a(baseData + counter));
}
var DirectFeedbackCallToAction = function (param) {
  var data = param.data,
    eventDispatch = param.eventDispatch,
    forcePostSubmit = param.forcePostSubmit;
  var _data_postSubmitDisplay, _promptData_directFeedbackPromptById, _promptData;
  var _useState8 = _sliced_to_array(useState8(function () {
      return generateDialogId(data.promptId, data.contextValues);
    }), 1),
    dialogQueryId = _useState8[0];
  var _useDialog2 = _sliced_to_array(useDialog2(dialogQueryId, "cdfPromptDialog"), 2),
    isOpen = _useDialog2[0],
    actions = _useDialog2[1];
  var _useState81 = _sliced_to_array(useState8(false), 2),
    wasSubmitted = _useState81[0],
    setWasSubmitted = _useState81[1];
  var handlePromptEvent = useCallback15(function (event) {
    switch (event.type) {
      case 0 /* Submit */:
        setWasSubmitted(true);
        break;
      default:
        break;
    }
    if (eventDispatch) {
      eventDispatch(event);
    }
  }, [setWasSubmitted, eventDispatch]);
  var CallToActionComponent = callToActionComponentLookup(data.callToAction.__typename);
  var PostSubmitComponent = postSubmitComponentLookup((_data_postSubmitDisplay = data.postSubmitDisplay) === null || _data_postSubmitDisplay === void 0 ? void 0 : _data_postSubmitDisplay.__typename);
  var contextValues = data.contextValues.map(function (value) {
    return {
      key: value.key,
      value: value.value
    };
  });
  var context = useBexApi2().context;
  var variables = {
    promptId: data.promptId,
    context: context
  };
  var _useQuery2 = useQuery2(__Query, {
      variables: variables,
      skip: !data.eager && !isOpen
    }),
    promptData = _useQuery2.data,
    loading = _useQuery2.loading;
  var hasPages = !!((_promptData = promptData) === null || _promptData === void 0 ? void 0 : (_promptData_directFeedbackPromptById = _promptData.directFeedbackPromptById) === null || _promptData_directFeedbackPromptById === void 0 ? void 0 : _promptData_directFeedbackPromptById.pages[0]);
  var _useMutation2 = _sliced_to_array(useMutation2(__SubmitFeedbackMutation), 2),
    submit = _useMutation2[0],
    _useMutation2_ = _useMutation2[1],
    submitData = _useMutation2_.data,
    submitLoading = _useMutation2_.loading;
  var useDirectFeedbackDialog = hasPages || !promptData && !loading;
  useEffect3(function () {
    if (!useDirectFeedbackDialog && isOpen && !!promptData && !submitLoading && !submitData) {
      submit({
        variables: {
          context: context,
          feedback: {
            formValues: [],
            context: contextValues
          },
          id: data.promptId
        }
      }).then(function () {
        actions.closeDialog();
        handlePromptEvent(new DirectFeedbackSubmitEvent(data.promptId, contextValues, []));
      });
    }
  }, [actions.closeDialog, submitLoading, submitData, useDirectFeedbackDialog, isOpen, submit, context, contextValues, promptData, data.promptId, handlePromptEvent, actions]);
  return /* @__PURE__ */React35.createElement(React35.Fragment, null, (wasSubmitted || !!forcePostSubmit) && !!PostSubmitComponent ? /* @__PURE__ */React35.createElement(PostSubmitComponent, {
    data: data.postSubmitDisplay,
    onClick: actions.openDialog
  }) : /* @__PURE__ */React35.createElement(CallToActionComponent, {
    data: data.callToAction,
    onClick: actions.openDialog
  }), useDirectFeedbackDialog ? /* @__PURE__ */React35.createElement(DirectFeedbackDialog, {
    inputs: {
      promptId: data.promptId
    },
    dialogQueryId: dialogQueryId,
    eventDispatch: handlePromptEvent,
    contextValues: contextValues
  }) : null);
};
DirectFeedbackCallToAction.fragment = fragment30;
DirectFeedbackCallToAction.displayName = "DirectFeedbackCallToAction";
export { DirectFeedbackCallToAction, DirectFeedbackDialog, DirectFeedbackEventType, DirectFeedbackPrompt }; /* istanbul ignore next -- @preserve */